import { Reveal } from "./Reveal";

export default function SectionHeading({ overline, title, subtitle, center = false, className = "" }) {
  return (
    <Reveal className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
      {overline && (
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">{overline}</p>
      )}
      <h2 className="mt-4 font-display text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-slate-400">{subtitle}</p>}
    </Reveal>
  );
}
